<template>
     <div class="hd_banner no-trans" v-loading="loading">
            <el-carousel ref="activity_carousel" :autoplay="true" :loop="true" :style="{ '--banner-ratio': banner_ratio }" @touchstart.native.passive="banner_touch_start" @touchend.native.passive="banner_touch_end">
                <el-carousel-item v-for="(item, index) in banner_list" :key="index">
                    <div class="banner_img">
                        <!-- <img src="@/assets/img/index/home/banners.jpg" alt=""> -->
                         <img :src="item.image" alt="" @load="index === 0 && (banner_ratio = $event.target.naturalWidth / $event.target.naturalHeight)" @click="handle_path(item)">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    props:{
        id:{
            type: Number,
             default: 0
		},
    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_list:[],
            banner_ratio: 1920 / 260,
            banner_touch: null,
            banner_swiped: false,
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_banner()
    },
    methods: {
        banner_touch_start(event) {
            this.banner_swiped = false
            if (!this.mobile_view || event.touches.length !== 1) return
            this.banner_touch = { x: event.touches[0].clientX, y: event.touches[0].clientY }
        },
        banner_touch_end(event) {
            const start = this.banner_touch
            this.banner_touch = null
            if (!this.mobile_view || !start || !event.changedTouches.length) return
            const dx = event.changedTouches[0].clientX - start.x
            const dy = event.changedTouches[0].clientY - start.y
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                this.banner_swiped = true
                this.$refs.activity_carousel[dx < 0 ? 'next' : 'prev']()
            }
        },
        get_banner(){
            this.loading=true
            this.$api("getBanner", {
                position:this.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('bannersid:'+this.id,res)
                if (res.code == 1) {
                   this.banner_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_path(item){
            if (this.mobile_view && this.banner_swiped) return
            if(item.url){
                window.open(item.url)
            }
        },


    },

}
</script>
<style scoped lang="less">
 .hd_banner {
        width: 100%;
        // width: 1920px;
        height: 260px;

        /deep/.el-carousel {
            height: 260px;

            .el-carousel__container {
                height: 100%;

                .banner_img {
                    width: 100%;
                    height: 100%;
                    img {
                        width: 100%;
                        height: 100%;
                    }

                }
            }

            .el-carousel__indicators {
                // position: relative;
                z-index: 101;
                // margin-top: 20px;
                // bottom: -5px;

                .el-carousel__indicator {
                    .el-carousel__button {
                        width: 10px;
                        height: 10px;
                        background: #FFFFFF;
                        border-radius: 50%;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 40px;
                        height: 10px;
                        background: #377CFD;
                        border-radius: 5px 5px 5px 5px;
                        // .opacity
                        opacity: 1;
                    }
                }
            }
        }
    }
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .hd_banner.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        min-height: 0;
        height: auto;
    }
    .hd_banner.no-trans /deep/ .el-carousel {
        height: auto;
        .el-carousel__container { height: auto; aspect-ratio: var(--banner-ratio); }
        .banner_img img { display: block; object-fit: contain; }
        .el-carousel__indicators { bottom: 0; display: flex; align-items: center; }
        .el-carousel__indicator { padding: 8px 5px; }
    }
    .hd_banner.no-trans /deep/ .el-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button {
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }
    .hd_banner.no-trans /deep/ .el-carousel .el-carousel__indicators .is-active .el-carousel__button {
        width: 18px;
        height: 6px;
        border-radius: 5px 5px 5px 5px;
    }
}
</style>
